"use strict";

exports.__esModule = true;
exports.AppHomeScreen = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _API = require("../../API");
var _Core = require("../../Core");
var _AppNavbar = require("../AppNavbar");
var _AppList = require("./AppList");
var _Theme = require("../../Theme");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "AppHomeScreen__Container",
  componentId: "sc-10m14lp-0"
})(["position:absolute;top:0;bottom:0;width:100%;background:", ";.plant-name{color:", ";font-size:20px;font-weight:400;position:absolute;top:20px;left:15px;}.copyright-bottom{color:", ";position:absolute;bottom:15px;text-align:center;width:100%;}.powered-by-logo{position:absolute;bottom:15px;left:50%;margin-left:-0.5 * 190px;}"], (0, _Theme.val)("AppHomeScreenBackground"), (0, _Theme.val)("SidebarPrimaryText"), (0, _Theme.val)("SidebarPrimaryText"));
var Outer = _styledComponents["default"].div.withConfig({
  displayName: "AppHomeScreen__Outer",
  componentId: "sc-10m14lp-1"
})(["display:table;position:absolute;height:100%;width:100%;"]);
var PageContainer = _styledComponents["default"].div.withConfig({
  displayName: "AppHomeScreen__PageContainer",
  componentId: "sc-10m14lp-2"
})(["display:table-cell;vertical-align:middle;"]);
var AppContainer = _styledComponents["default"].div.withConfig({
  displayName: "AppHomeScreen__AppContainer",
  componentId: "sc-10m14lp-3"
})(["margin-left:auto;margin-right:auto;max-width:900px;"]);
var Logo = _styledComponents["default"].div.withConfig({
  displayName: "AppHomeScreen__Logo",
  componentId: "sc-10m14lp-4"
})(["position:relative;max-width:490px;text-align:center;margin:auto;margin-bottom:20px;img{max-width:100%;}"]);
var AppHomeScreen = exports.AppHomeScreen = (0, _styledComponents.withTheme)(function (_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  var _React$useContext = _react["default"].useContext(_API.RestAPIContext),
    plantName = _React$useContext.plantName;
  var _React$useContext2 = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext2.translate;
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("AppHomeScreen.title", "Home"),
    className: "AppHomeScreen"
  }, /*#__PURE__*/_react["default"].createElement(_AppNavbar.AppNavbar, {
    title: plantName,
    style: {
      background: "none",
      border: "none"
    }
  }), /*#__PURE__*/_react["default"].createElement(Container, {
    className: "AppHomeScreen_Container"
  }, /*#__PURE__*/_react["default"].createElement(Outer, null, /*#__PURE__*/_react["default"].createElement(PageContainer, null, /*#__PURE__*/_react["default"].createElement(AppContainer, null, /*#__PURE__*/_react["default"].createElement(Logo, null, /*#__PURE__*/_react["default"].createElement("img", {
    src: theme.LandingLogo.slice(4, -1),
    alt: "Logo"
  })), /*#__PURE__*/_react["default"].createElement(_AppList.AppList, null), children)))));
});